module.exports = __webpack_public_path__ + "img/dreamTeam.13686569.svg";